export default __webpack_public_path__ + "static/media/about-us-2.f354bc94.png";